/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";
import TimeSlotsSkeleton from "./TimeSlotsSkeleton";

const StyledItem = styled((props) => <BookingStepItem {...props} />)`
  padding: 1rem;
`;

const ItemInner = styled.div`
  display: grid;
  place-content: start;
  align-items: center;
  grid-template-columns: auto 1fr;
  gap: 0 1rem;
`;

const SkeletonSlots = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-column: 2 / span 2;

  ${({ theme }) => theme.containerMedia.sm} {
    grid-column: 1 / span 2;
    margin-top: 1rem;
  }
`;

const SkeletonSlotsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 0.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ProviderItemSkeleton = () => {
  return (
    <StyledItem>
      <ItemInner>
        <Skeleton borderRadius="50%" width={40} height={40} />
        <SkeletonText size="h3" width="40%" />
        <SkeletonSlots>
          <SkeletonText size="small" width="60%" />
          <SkeletonSlotsGrid>
            <TimeSlotsSkeleton count={4} />
          </SkeletonSlotsGrid>
        </SkeletonSlots>
      </ItemInner>
    </StyledItem>
  );
};

export default ProviderItemSkeleton;
